var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"areasimple"}},[_c('div',{staticClass:"lineChart Chart",attrs:{"id":_vm.useData.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }